export default __webpack_public_path__ + "static/media/36.c557fa6c.jpg";